import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { IconButton } from "@mui/material";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { ContactsDialog } from "../../page/PersonRepositoryPage/ContactsDialog";
import { useGetAgreementDetailsForNewContactMutation } from "../../services/agreementsService";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { CircularProgress } from "@mui/material";
import { isEmptyArray } from "../../helpers/methods";
import { SelectPersonDialog } from "./SelectPersonDialog";

import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";;
import { SnackbarError } from "../../components/base/SnackbarAlert/SnackbarError";


export function AddContactForAgreementOverduePaymentButton({ agreementId, agreementOverduePaymentId, overduePaymentBalance, color = "primary" }) {
    const {t} = useTranslation();
    
    const { openDialog: openContactsDialog } = useDialogBetter();
    const { openDialog: openSelectPersonDialog } = useDialogBetter();
    const { mutate: getAgreementDetails, isPending } = useGetAgreementDetailsForNewContactMutation();

    const prepareDataForPayment = (payment) => {
        const deadlineDays = 1
        const deadlineDate = new Date( Date.now() - deadlineDays * 24 * 60 * 60 * 1000)
        return {
            id: payment.id,
            tranche_name: payment.tranche_name,
            agreement_payment_amount: payment.agreement_payment_amount,
            due_date: payment.agrepay_due_date,
            paid_amount: payment.paid_amount,
            remaining_amount: payment.remaining_amount,
            is_overdue_payment: (
                !payment.is_paid && payment.agrepay_due_date && new Date(payment.agrepay_due_date) < deadlineDate ||
                (payment.agreement_payment_is_final_settlement && payment.agreement_payment_amount < 0)
            ),
            agreement_payment_parent_id: payment.agreement_payment_parent_id,
            agreement_payment_parent_name: payment.agreement_payment_parent_name,
            agreement_payment_parent_amount: payment.agreement_payment_parent_amount,
            agreement_payment_is_final_settlement: payment.agreement_payment_is_final_settlement,
            is_paid: payment.is_paid,
        }
    }

    const onOpenContactDialog = (data)=> {
        openContactsDialog({
            Component: ContactsDialog,
            componentProps: {
                personId: data.person_id,
                agreementOverduePaymentId: agreementOverduePaymentId,
                overduePaymentBalance: overduePaymentBalance,
                rowData: {subject: "Overdue payment notification", 
                    rawPayments: data.raw_payments.map(payment=>prepareDataForPayment(payment)),
                    currentPayments: data.current_payments.map(payment=>prepareDataForPayment(payment),                                
                )},
            },
        });
    }

    const handleOpenContactDialog = () => {
        getAgreementDetails(
            {
                agreementId : agreementId,
            },
            {
                onSuccess: (data, variables, context) => {
                    if (isEmptyArray(data.person_ids)) {
                        toast.custom(
                            (curToast) => <SnackbarError message={t("snackbar_alert.to_create_contact_first_connect_person_to_company")} />,
                            {
                                position: "bottom-right",
                            },
                        );
                    }

                    else if (data.person_ids.length > 1) {
                        openSelectPersonDialog({
                            Component: SelectPersonDialog,
                            componentProps: {
                                person_ids: data.person_ids,
                                onConfirm: (person_id)=> onOpenContactDialog({...data, person_id: person_id})
                            }
                        })
                    }

                    else {
                        onOpenContactDialog({...data, person_id: data.person_ids[0]})
                    }
                },
            },
        );
    };

    return (
        isPending 
            ? <CircularProgress/>
            : <IconButton
                    color={color}
                    onClick={handleOpenContactDialog}
                >
                    <LocalPhoneIcon />
                </IconButton>
    );
}
